import React from 'react';
import { Typography, Grid, Button, makeStyles } from '@material-ui/core';
import { AiOutlineCheck } from 'react-icons/ai';
import { MdOutlineDelete, MdClose } from 'react-icons/md';

const useStyles = makeStyles((theme) => ({
    root: {
        padding: theme.spacing(3),
    },
    header: {
        marginBottom: theme.spacing(3),
        borderBottom: `1px solid ${theme.palette.divider}`,
        paddingBottom: theme.spacing(2),
    },
    metaInfo: {
        marginBottom: theme.spacing(2),
        color: theme.palette.text.secondary,
    },
    bodyContent: {
        marginBottom: theme.spacing(4),
        '& img': {
            maxWidth: '100%',
            height: 'auto',
        },
    },
    actionButtons: {
        display: 'flex',
        justifyContent: 'flex-end',
        gap: theme.spacing(2),
        marginTop: theme.spacing(3),
        borderTop: `1px solid ${theme.palette.divider}`,
        paddingTop: theme.spacing(2),
    },
}));

const NewsDetails = ({ record, onApprove, onDelete }) => {
    const classes = useStyles();

    if (!record) return null;

    return (
        <div className={classes.root}>
            <div className={classes.header}>
                <Typography variant="h4" component="h1" gutterBottom>
                    {record.title}
                </Typography>
                <Grid container spacing={2} className={classes.metaInfo}>
                    <Grid item>
                        <Typography variant="subtitle1">
                            <strong>Author:</strong> {record.author}
                        </Typography>
                    </Grid>
                    <Grid item>
                        <Typography variant="subtitle1">
                            <strong>Date:</strong> {new Date(record.createdAt).toLocaleString()}
                        </Typography>
                    </Grid>
                    <Grid item>
                        <div style={{
                            padding: '4px 12px',
                            borderRadius: '12px',
                            backgroundColor: record.status === 'approved' ? '#4caf50' : record.status === 'rejected' ? '#f44336' : '#ff9800',
                            color: 'white',
                            fontSize: '12px',
                            fontWeight: 'bold',
                            textTransform: 'uppercase',
                            display: 'inline-block'
                        }}>
                            {record.status || 'pending'}
                        </div>
                    </Grid>
                </Grid>
            </div>

            <Typography component="div" className={classes.bodyContent}>
                <div dangerouslySetInnerHTML={{ __html: record.body }} />
            </Typography>

            <div className={classes.actionButtons}>
                <Button
                    variant="outlined"
                    color="secondary"
                    startIcon={<MdClose />}
                    onClick={() => {
                        onDelete(record.Id);
                    }}
                >
                    Reject
                </Button>
                <Button
                    variant="contained"
                    color="primary"
                    startIcon={<AiOutlineCheck />}
                    onClick={() => {
                        onApprove(record.Id);
                    }}
                >
                    Approve
                </Button>
            </div>
        </div>
    );
};

export default NewsDetails;
